import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { ITabsProps } from '.';

export const generate = (
  props?: Partial<IComponentSchema<ITabsProps>>
): IComponentSchema<ITabsProps> => {
  const id = uuidv4();
  const tabPaneId = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.Tabs,
    'x-component-props': {
      type: props?.['x-component-props']?.type || 'line',
      ...props?.['x-component-props'],
    },
    'x-component-props-config': {},
    properties: props?.properties || {
      [tabPaneId]: {
        type: JsonFieldType.VOID,
        name: tabPaneId,
        'x-designable-id': tabPaneId,
        'x-index': 0,
        'x-component': ComponentType.TabPane,
        'x-component-props': {
          tab: 'Tab 1',
        },
        properties: {},
      },
    },
  };
};
